export default "__VITE_ASSET__CH8tDK2j__"